export const Message = (properties) => {
  const {
    message,
    type = 'standard',
    centering = 'center',
  } = properties;
  return (<>
    <section className={`notification ${centering} ${type}`}>
      <span className="message">{message}</span>
    </section>
  </>);
};
